export const UNGROUPED_RESOURCES_GROUP_ID = 'ungrouped-resources';
